/* eslint-disable class-methods-use-this */
import * as api from '../../../../utils/apiClient';
import { restructureTasksAccountSettingsModel } from './restructuring';

class TasksUpListService {
  async getMySettings(state) {
    const response = await api.get(
      `/tasks/account-settings/get-my-settings`,
      {}
    );
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: restructureTasksAccountSettingsModel(
        state,
        responseJson.data
      )
    };
  }
}

export default new TasksUpListService();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/services/TasksAccountSettingsService/TasksAccountSettingsService.js